module.exports = __webpack_public_path__ + "static/media/who-19.0af688b1.jpg";